import { useState, useCallback, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from 'contexts/AuthContext';

const useHttpClient = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const activeHttpRequest = useRef([]);
  const { clearLocalStorage, token } = useContext(AuthContext);

  const baseUrl = process.env.REACT_APP_API_endpoint + "/api";

  const sendRequest = useCallback(async (url, method = 'get', body = null) => {
    const controller = new AbortController();
    const signal = controller.signal;
    
    // Conditionally add Authorization header if token exists
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const options = { headers, signal };

    setIsLoading(true);
    try {
      const response = await axios({
        method,
        url: baseUrl + url,
        data: body,
        ...options
      });
      setIsLoading(false);
      return response;
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  }, [baseUrl, token]);

  const clearError = () => setError(null);

  useEffect(() => {
    return () => {
      activeHttpRequest.current.forEach(abortCtrl => abortCtrl.abort());
    };
  }, []);

  return { isLoading, error, sendRequest, clearError };
};

export default useHttpClient;
